<script>
import axios from "axios";
import { Line } from "vue-chartjs";

export default {

    extends: Line,

    props: {
        project: Object,
        values : Object,
    },

    mounted() {
        this.getStats();
    },

    inject: [ 'language' ],

    data() {

        return {
            debounce : null,
            debounceTimer : 1000
        }

    },

    watch: {

        values(newItems, oldItems) {

            if(oldItems !== newItems) {

                clearTimeout(this.debounce)

                this.debounce = setTimeout(() => {

                    this.getStats()

                }, this.debounceTimer)

            }

        },
    },

    methods: {

        getStats: function () {

            axios

            .post(`/api/get-admin-chart-data-line`, {
                project: this.project,
                values : this.values
            })

            .then((res) => {

                if (res.data) {

                    let dates = [], opinions = [], users = [], visitors = [], temp = [];

                    if(res.data.answers_per_day) {
                        for (const property in res.data.answers_per_day) {
                            temp.push({ date : property, count : res.data.answers_per_day[property]})
                        }

                        opinions = temp.sort((a,b) => new Date(a.date) - new Date(b.date)).map(item => item.count)
                        temp = [];
                    }

                    if(res.data.dates) {
                        for (const [key, value] of Object.entries(res.data.dates)) {
                            dates.push(value);
                        }
                    }

                    if(res.data.users_per_day) {
                        for (const property in res.data.users_per_day) {
                            temp.push({ date : property, count : res.data.users_per_day[property]})
                        }

                        users = temp.sort((a,b) => new Date(a.date) - new Date(b.date)).map(item => item.count)
                        temp = [];
                    }

                    if(res.data.visitors_per_day) {
                        for (const property in res.data.visitors_per_day) {
                            temp.push({ date : property, count : res.data.visitors_per_day[property]})
                        }

                        visitors = temp.sort((a,b) => new Date(a.date) - new Date(b.date)).map(item => item.count)
                        temp = [];
                    }

                    if(res.data.total_answers) {
                        let opinionsValue = 0;

                        if(opinions.length) {
                            opinionsValue = opinions.reduce((a, b) => a + b);
                        }

                        this.$emit('total-answers', {
                            current : opinionsValue,
                            total : res.data.total_answers
                        })
                    }

                    if(res.data.total_users) {

                        let usersValue = 0;

                        if(users.length) {
                            usersValue = users.reduce((a, b) => a + b);
                        }

                        this.$emit('total-users', {
                            current : usersValue,
                            total : res.data.total_users
                        })
                    }

                    if(res.data.total_visitors) {
                        this.$emit('total-visitors', res.data.total_visitors)
                    }

                    this.renderChart(
                        {
                            labels: dates,
                            datasets: [
                                {
                                    label: this.language.views,
                                    borderColor: "#f87979",
                                    backgroundColor: "transparent",
                                    data: opinions,
                                },
                                {
                                    label: this.language.participant,
                                    borderColor: "green",
                                    backgroundColor: "transparent",
                                    data: users,
                                },
                                {
                                    label: this.language.number_of_visitors,
                                    borderColor: "blue",
                                    backgroundColor: "transparent",
                                    data: visitors,
                                }
                            ],
                        },
                        {
                            legend: {
                                onClick: (e) => e.stopPropagation()
                            },

                            responsive: true,
                            maintainAspectRatio: false,

                            plugins: {
                                datalabels: {
                                    formatter: (value, ctx) => {
                                        return null
                                    },
                                }
                            }
                        }
                    );

                    this.$data._chart.update()

                    this.$emit( 'line-chart-rendered', true )

                }
            })

            .catch((err) => {
                console.error(err);
            });

        },
    },
};
</script>

